<template>
  <div class="member__server" v-if="[25, 30].includes(activeTab)">
    <div class="title">学习服务</div>
    <div class="study__servers" v-if="activeTab === 30">
      <div class="study__server item1" @click="goStudy(1)">
        <div class="text">人工批改</div>
        <div class="desc">作业精准指导</div>
        <div class="icon"></div>
      </div>
      <div class="study__server item2" @click="goStudy(2)">
        <div class="text">人工答疑</div>
        <div class="desc">让问题不再无解</div>
        <div class="icon"></div>
      </div>
      <!-- <div :class="`study__server ${userMemberInfo.level === 30 ? 'item4' : 'item3'}`" @click="goStudy(3)">
        <div class="text">1对1择校</div>
        <div class="desc">精细化择校服务</div>
        <div class="icon"></div>
      </div> -->
    </div>
    <div v-if="[25, 30].includes(activeTab)" class="study__one-v-one" @click="goStudy(3)">
      <img
        referrerpolicy="no-referrer"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/member-1v1.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { whatEev, setBaseUrl } from '@/utils/tools';
import wx from 'weixin-js-sdk';
import { miniSchemeUrl } from '@/utils/common';


export default {
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    activeTab: {
      type: Number,
      value: 20,
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员
        levelName: '普通用户',
        deadlineStartTime: '',
        deadlineEndTime: '', // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      }),
    },
    benefitList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    goStudy(key) {
      // 没解锁无点击事件
      if (!this.isUnlock) return;
      switch (key) {
        case 1:
          this.correction();
          break;
        case 2:
          this.answerQuestion();
          break;
        default:
          this.chooseSchool();
      }
    },
    correction() {
      this.goPage('/pages/index/index', 'pigai');
    },
    // 跳转页面
    goPage(url, redirctPage = '') {
      if (whatEev() === 'miniprogram') {
        if (redirctPage) {
          wx.miniProgram.navigateTo({
            url: `/pages/redirectOtherMini/index?redirctPage=${redirctPage}`,
          });
        } else {
          wx.miniProgram.navigateTo({
            url,
          });
        }
      } else if (this.$root.$data.isApp) {
        if (redirctPage === 'pigai') {
          this.$sendToApp('goWechatProject', {
            userName: 'gh_affc8f949922',
            path: url,
          });
          return;
        }
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: url,
        });
      } else {
        this.getSchemeUrl(url, redirctPage);
      }
    },
    // h5 打开小程序的方法
    async getSchemeUrl(path, redirctPage) {
      let data = {
        appid: 'wxdb89cfa2bb60f779',
        path,
        envVersion: !window.location.host.includes('mobile-test') ? 'release' : 'trial',
      };
      if (redirctPage === 'pigai') {
        data = {
          appid: 'wx28d0c1323b01e8d9',
          path,
          envVersion: !window.location.host.includes('mobile-test') ? 'release' : 'trial',
        };
      }
      const schemeLink= await  miniSchemeUrl(data.appid,data.path)
      window.location.href=schemeLink;
    },
    answerQuestion() {
      const index = this.benefitList.findIndex(item => item.title === '人工答疑');
      this.$router.push({
        path: '/personalCenter/benefits',
        query: {
          activeTab: this.activeTab,
          hiddenNavigationBar: 1,
          index: index > -1 ? index : 0,
          back: 'back',
        },
      });
    },
    chooseSchool() {
      const url = `${setBaseUrl('')}/iform/index/267`;
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/webView/webView?url=${encodeURIComponent(url)}`,
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
      } else {
        window.location.href = url;
      }
    },
  },
  computed: {
    isUnlock() {
      const level = Number(this.userMemberInfo.level) || 0;
      const tab = Number(this.activeTab);
      const { id } = this.userInfo;
      if (!id) return false;
      if (tab === 25) return level === 25 || level === 30;
      if (tab === 30) return level === 30;
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../index.scss';

.member__server {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 678px;
  margin: 0 auto 36px;
}

.title {
  width: 100%;
  margin-bottom: 22px;
  color: #333;
  font-weight: 500;
  font-size: 29px;
}

.study__servers {
  width: 681px;
  margin-bottom: 18px;
  padding: 18px 0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  background: linear-gradient(224deg, #FFDEAC 0%, #E3B177 100%);
  border-radius: 14px;

  &::-webkit-scrollbar {
    display: none;
  }
}

.study__server {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  width: 313px;
  height: 118px;
  margin-left: 18px;
  padding: 24px 22px;
  overflow: hidden;
  vertical-align: middle;
  background: #FFF;
  border-radius: 11px;

  .text {
    color: #333;
    font-weight: 500;
    font-size: 25px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 36px;
  }

  .desc {
    color: #333;
    font-weight: 400;
    font-size: 20px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 29px;
  }

  .icon {
    @include background(82px, 82px);

    position: absolute;
    top: 18px;
    right: 18px;
  }

  &.item1 {
    .icon {
      @include backgroundImage('member_pigai.png');
    }
  }

  &.item2 {
    .icon {
      @include backgroundImage('member_dayi.png');
    }
  }

  &.item3 {
    margin-right: 18px;

    .icon {
      @include backgroundImage('member_zexiao.png');
    }
  }

  &.item4 {
    margin-right: 18px;

    .icon {
      @include backgroundImage('member_yuyue.png');
    }
  }
}

.study__one-v-one {
  width: 681px;
  height: 154px;
  padding: 18px;
  overflow: hidden;
  background: linear-gradient(224deg, #FFDEAC 0%, #E3B177 100%);
  border-radius: 14px;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
